import type { SubscriptionType } from '../types/subscription';
import isPaidHostingPackageType from './is-paid-hosting-package-type';

function hasPaidHostingPackageType(types: SubscriptionType[]): boolean {
  return types.some(isPaidHostingPackageType);
}

export default hasPaidHostingPackageType;
